import { ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import packageJson from '../../../../package.json';
import { MenuItemService } from '../sidebar/sidebar.service';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-sidebar-drawer',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavModule,
    RouterOutlet,
    SidebarComponent
  ],
  templateUrl: './sidebar-drawer.component.html',
  styleUrl: './sidebar-drawer.component.scss'
})
export class SidebarDrawerComponent implements OnInit {

  @ViewChild('sidenav') public sidenav?: MatSidenav;

  isExpanded = false;
  showVersion = true;
  version = packageJson.version;

  mobileQuery: MediaQueryList;
  changeDetectorRef: ChangeDetectorRef;

  private _mobileQueryListener: () => void;

  constructor(private readonly menuItemService: MenuItemService) {

    this.changeDetectorRef = inject(ChangeDetectorRef);
    const media = inject(MediaMatcher);
    
    this.mobileQuery = media.matchMedia('(max-width: 700px)');
    this._mobileQueryListener = () => {
      this.changeDetectorRef.detectChanges();
      this.toggleMenu();
    }
    this.mobileQuery.addEventListener("change", this._mobileQueryListener, {passive: true});
  }

  ngOnInit() {
    this.menuItemService.sideNavToggleSubject.subscribe(() => {
      this.toggleMenu();
    });
  }

  ngOnDestroy(): void {
    if (this.mobileQuery) { // @ts-ignore
      this.mobileQuery.removeAllListeners();
    }
  }

  public toggleMenu() {
    this.isExpanded = !this.isExpanded;
  }
}